'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var Fraction = function (_PureComponent) {
  (0, _inherits3.default)(Fraction, _PureComponent);
  function Fraction() {
    (0, _classCallCheck3.default)(this, Fraction);
    return (0, _possibleConstructorReturn3.default)(this, (Fraction.__proto__ || (0, _getPrototypeOf2.default)(Fraction)).apply(this, arguments));
  }
  (0, _createClass3.default)(Fraction, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 1024 1024',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('g', null, _react2.default.createElement('path', {
        d: 'M167.218 251.678v512.244H87.91V337.814L3.65 381.264V302.75l100.992-51.072h62.578zM414.428 251.678v512.244H335.12V337.814l-84.262 43.45V302.75l100.992-51.072h62.578zM624.464 251.678h70.013L549.494 763.922H479.48l144.984-512.244zM1022.227 657.204h-56.382v106.718h-73.112V657.204h-207.56v-70.128l177.2-335.398h78.688L765.1 583.265h127.633V443.77h73.112v139.495h56.382v73.94z'
      })));
    }
  }]);
  return Fraction;
}(_react.PureComponent);
Fraction.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = Fraction;